//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionObject.js";
let d=[[[0,"NormalModeCount",0,0]],[[["mode_id"],"GetNormalModeById",{R_:{normal_mode:"Motion.NormalModeProperty"}},1,0],[["num_modes"],"GetNormalModes",{R_:{normal_modes:"Motion.NormalModeProperty[]"}},0,0],[["activate"],"Activate",{},1,0],[[],"GetPhysicalDampingSettings",{R_:{physical_damping_settings:"Motion.FlexPhysicalDampingSettings"}},0,0],[[],"GetFlexibleDampingSettings",{R_:{flexDamping:"Motion.FlexDamping"}},0,0],[[],"GetFlexibleDampingBuilder",{R_:{flexDamping:"Motion.FlexDampingBuilder"}},0,0],[[],"LoadFlexComputationResult",{R_:{caeResult:"CAE.Result"}},0,0],[[],"AutoUpdate",{},0,0],[["connectionTag","connectionPositionId"],"GetConnectionNodeId",{R_:{nodeLabel:''}},2,0]],[]];
SPLM.Motion.FlexBody = class extends SPLM.Motion.MotionObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.FlexBody";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;